export const table = [
  { title: 'Номер заявки', id: 1, name: 'id' },
  { title: 'Агент', id: 2 },
  { title: 'Почта', id: 3 },
  { title: 'Дата оплаты', id: 4, name: 'date' },
  { title: 'Выплачено', id: 5 },
];
